import { render, staticRenderFns } from "./AwaitingFile.vue?vue&type=template&id=484e4e30&scoped=true"
import script from "./AwaitingFile.vue?vue&type=script&lang=js"
export * from "./AwaitingFile.vue?vue&type=script&lang=js"
import style0 from "./AwaitingFile.vue?vue&type=style&index=0&id=484e4e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484e4e30",
  null
  
)

export default component.exports